import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CountSystemReferenceService extends BaseReferenceService {
  constructor() {
    super('CountSystemReference');
  }
}
